import type { SseTrainMessage, SseCarMessage, SseFoodMessage, SseGuideMessage, SseFlightMessage, SseRouteMessage, SseTransferMessage, SseHotelMessage, TransferPlanItem, TrainItem, CarItem, FoodItem, GuideItem, FlightItem, HotelSearchItem } from "@/api/aiChat";
import TrainCard from "./train-card";
import CarCard from "./car-card";
import FoodCard from "./food-card";
import GuideCard from "./guide-card";
import FlightCard from "./flight-card";
import RouteCard from "./route-card";
import TransferCard from "./transfer-card";
import HotelCard from "./hotel-card";
import OrderCard from "./order-card";

// ════════════════════════════════════════════════════
//  主入口：根据 msg_type 分发到对应卡片
// ════════════════════════════════════════════════════

export default function QueryResultCard({
  msg_type,
  queryData,
  onTrainSelect,
  onCarSelect,
  onFoodSelect,
  onGuideSelect,
  onFlightSelect,
  onTransferSelect,
  onHotelSelect,
}: {
  msg_type?: string;
  queryData?: any;
  onTrainSelect?: (train: TrainItem) => void;
  onCarSelect?: (car: CarItem) => void;
  onFoodSelect?: (food: FoodItem) => void;
  onGuideSelect?: (guide: GuideItem) => void;
  onFlightSelect?: (flight: FlightItem) => void;
  onTransferSelect?: (plan: TransferPlanItem) => void;
  onHotelSelect?: (hotel: HotelSearchItem) => void;
}) {
  if (!msg_type || !queryData) return null;

  switch (msg_type) {
    case "train":
      return <TrainCard data={queryData as SseTrainMessage} onTrainSelect={onTrainSelect} />;
    case "car":
      return <CarCard data={queryData as SseCarMessage} onCarSelect={onCarSelect} />;
    case "food":
      return <FoodCard data={queryData as SseFoodMessage} onFoodSelect={onFoodSelect} />;
    case "guide":
      return <GuideCard data={queryData as SseGuideMessage} onGuideSelect={onGuideSelect} />;
    case "flight":
      return <FlightCard data={queryData as SseFlightMessage} onFlightSelect={onFlightSelect} />;
    case "hotel":
      return <HotelCard data={queryData as SseHotelMessage} onHotelSelect={onHotelSelect} />;
    case "route":
      return <RouteCard data={queryData as SseRouteMessage} />;
    case "transfer":
      return <TransferCard data={queryData as SseTransferMessage} onTransferSelect={onTransferSelect} />;
    default:
      // 预定订单消息：action="book" 时用 __data 渲染订单卡片
      if (queryData?.__data) {
        return <OrderCard orderData={queryData.__data} />;
      }
      return null;
  }
}
